import {xhrRequest} from './xhr'
import sanitize from 'sanitize-filename'

export function s3Upload(
  url: string,
  file: File,
  onProgress?: (ev: ProgressEvent<EventTarget>, xhr: XMLHttpRequest) => void
) {
  return xhrRequest(url, {method: 'put', body: file}, onProgress)
}

// copy of common/s3, too complicated to extract out as the workbench needed extra dependencies installed
export const makeS3FileId = (rawFilename: string) =>
  sanitize(rawFilename.replace(/[^\w.]/g, '-'))
